/**
 * Constants for direct WebSocket orderbook connections
 * Follows the same patterns as useHyperliquidOrderBookWS.ts
 */
import { EXCHANGES } from "@cede/utils";

// Throttle delay between orderbook updates (prevents render thrashing)
export const THROTTLE_DELAY = 100; // 100ms

// Max reconnection attempts before giving up
export const MAX_RECONNECT_ATTEMPTS = 10;

// Max delay between reconnection attempts (exponential backoff cap)
export const MAX_RECONNECT_DELAY = 30_000; // 30 seconds

// Exchanges that support direct WebSocket orderbook
// Note: MEXC requires backend proxy for REST API (CORS blocked) + version-based sync
export const DIRECT_WS_SUPPORTED_EXCHANGES = [
  EXCHANGES.BINANCE,
  EXCHANGES.OKX,
  EXCHANGES.GATEIO,
  EXCHANGES.BITGET,
  EXCHANGES.BITMART,
  EXCHANGES.BITSTAMP,
  EXCHANGES.BYBIT,
  EXCHANGES.COINBASE,
  EXCHANGES.HTX,
  EXCHANGES.KRAKEN,
  EXCHANGES.KRAKEN_FUTURES,
  EXCHANGES.CRYPTOCOM,
  EXCHANGES.KATANA,
] as const;

export type DirectWSSupportedExchange = (typeof DIRECT_WS_SUPPORTED_EXCHANGES)[number];

/**
 * Check if an exchange supports direct WebSocket orderbook
 */
export function isDirectWSSupported(exchangeId: string): exchangeId is DirectWSSupportedExchange {
  return DIRECT_WS_SUPPORTED_EXCHANGES.includes(exchangeId as DirectWSSupportedExchange);
}
